var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useTracker } from '@jetshop/core/analytics/Analytics';
import { trackProductEvent } from '@jetshop/core/analytics/tracking';
import useWarningInDev from '@jetshop/core/hooks/useWarningInDev';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router';
import { useRoutePreload } from '@jetshop/core/hooks/useRoutePreload';
import { useHoverIntent } from './utils/useHoverIntent';
import { breadcrumbsWithoutProduct } from '@jetshop/core/analytics/utils/breadcrumbsWithoutProduct';
import { useShopConfig } from '@jetshop/core/hooks/useShopConfig';
export function getPathWithTrailingSlash(path) {
    if (path.endsWith('/')) {
        return path;
    }
    else
        return path + '/';
}
const ProductLink = (_a) => {
    var { product, index, list, children, onClick, categoryPath, search, hash } = _a, rest = __rest(_a, ["product", "index", "list", "children", "onClick", "categoryPath", "search", "hash"]);
    const track = useTracker();
    const { preload } = useRoutePreload();
    useWarningInDev(!product, `You must pass a product to ProductLink`);
    const location = useLocation();
    let pathname = '/';
    const { usePrimaryRouteForProducts } = useShopConfig();
    const productPreload = () => {
        preload({
            pathname,
            routeType: 'Product'
        });
    };
    const [, intentRef] = useHoverIntent({
        onHover: () => {
            productPreload();
        }
    });
    if (!product || !product.primaryRoute) {
        return React.createElement(React.Fragment, null, children ? children : product.name);
    }
    const { primaryRoute, id } = product;
    pathname =
        categoryPath && !usePrimaryRouteForProducts
            ? getPathWithTrailingSlash(categoryPath.path) + primaryRoute.slug
            : primaryRoute.path;
    return (React.createElement(Link, Object.assign({}, rest, { onClick: (event) => {
            var _a;
            track(trackProductEvent({
                action: 'click',
                product,
                list,
                index,
                category: breadcrumbsWithoutProduct((categoryPath === null || categoryPath === void 0 ? void 0 : categoryPath.breadcrumbs) || ((_a = product.primaryRoute) === null || _a === void 0 ? void 0 : _a.breadcrumbs))
            }));
            onClick && onClick(event);
        }, to: {
            pathname,
            state: {
                type: 'Product',
                id,
                product: Object.assign(Object.assign({}, product), { inPackages: [], variants: {
                        options: [],
                        values: []
                    }, stockStatus: {} }),
                list: list || (location.state ? location.state.list : null)
            },
            search,
            hash
        }, innerRef: intentRef, onTouchStart: productPreload }), children ? children : product.name));
};
export default ProductLink;
//# sourceMappingURL=ProductLink.js.map